import SpinnerIcon from "@/assets/svg/spinner.svg?react";

/**
 *
 * @param size - The size of the spinner in pixels
 * @returns
 */
export function Spinner({ size = 20 }: { size?: number }) {
  return (
    <div className={`animate-spin-reverse w-fit h-auto`}>
      <SpinnerIcon height={size} width={size} />
    </div>
  );
}
